import { DrawOrderConstants } from '@cgs/machines';

export const enum TrifectaHudZIndex {
  GameSettingsPopup = DrawOrderConstants.Top + 2,
}
